//
// GTLGraphState.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "./LayoutViewportState";
import "./RendererState";
import "../data/DiscreteSort";

var GTLGraphState = createModule("gtl::GTLGraphState", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        dataAnimationKeyframeValue: 7,
        rendererStates: [1],
        layoutViewports: [1],
        discreteSorts: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default GTLGraphState;
